<template>
	<div
		class="ProductsItemClassic"
		:class="{
			'ProductsItemClassic--dark': client.name === 'Dolci',
			'ProductsItemClassic--light': client.name !== 'Dolci',
		}"
	>
		<div class="ProductsItemClassic__top">
				<h6 class="ProductsItemClassic__name">{{ getTranslation(item.name) }}</h6>

				<span class="ProductsItemClassic__price">{{ item.price }}</span>
		</div>

		<div
			class="ProductsItemClassic__content"
		>
			<div
				v-if="item.images.length"
				class="ProductsItemClassic__wrapper"
			>
				<img
					v-lazy="{'src': getImage}"
					alt="Dishes"
					class="ProductsItemClassic__img"
				>
			</div>

			<p
				class="item-details__list"
				:class="{
					'item-details__list--dark': client.name === 'Dolci',
					'item-details__list--light': client.name !== 'Dolci',
				}"
			>
				{{ getTranslation(item.description) }}
			</p>
		</div>

		<div v-if="tableId && client.online_order" class="ProductsItemClassic__lower">
			<button
				class="ProductsItemClassic__action"
				@click="selectProduct(item)"
				:disabled="addedToOrder"
			>
				<span>
					<template v-if="addedToOrder">Added</template>
					<template v-else>Add to order</template>
				</span>
			</button>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
	props: [
		'item',
		'selectProduct',
	],

	data () {
		return {
			quantity: 1,
			addedToOrder: false,
		}
	},

	computed: {
		...mapGetters({
			tableId: 'session/tableId',
		}),

		getImage () {
			return this.item.images[0]
		},
	},

	methods: {
		...mapActions({
			addOrderProduct: 'orders/addOrderProduct',
		}),

		prepareOrder (event) {
			event.stopPropagation()

			const order = {
				product: [this.item],
				order_quantity: 1,
			}

			this.addOrderProduct(order)

			this.addedToOrder = true
		},
	},
}
</script>

<style lang="scss" scoped>
	.ProductsItemClassic {
		position: relative;
		overflow: hidden;
		padding: 20px 0;

		@media (min-width: 768px) {
			width: 70%;
			margin: 0 auto;
		}

		&__top {
			display: flex;
			justify-content: space-between;
			flex-direction: row;
			position: relative;
			padding: 0 16px;

			&::before {
				content: '';
				position: absolute;
				bottom: 0;
				left: 28px;
				width: 100%;
				height: 1px;
				background: grey;
			}
		}

		&__content {
			position: relative;
		}

		&__wrapper {
			height: 300px;
			padding-left: 28px;
			padding-top: 6px;
			overflow: hidden;
		}

		&__img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			object-position: 1 0;
		}

		&__lower {
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex-direction: row-reverse;
			margin-top: 4px;
		}

		&__name {
			font-size: 16px;
			text-transform: uppercase;
			margin-bottom: 0;
		}

		&__price {
			padding: 0;
			display: flex;
			align-items: center;
			font-size: 16px;
			line-height: 17px;
			font-weight: 500;
			background: transparent;
		}

		&__action {
			height: 48px;
			display: inline-block;
			font-weight: 600;
			text-transform: uppercase;

		}

		&__action:disabled {
			border: 2px solid rgba(0, 0, 0, 0.555);
			color: rgba(0, 0, 0, 0.555);
		}

		&--light {
			.ProductsItemClassic__name {
				color: #24242E;
			}

			.ProductsItemClassic__price {
				color: black;
			}

			.ProductsItemClassic__action {
				background: white;
				color: black;
				border: 2px solid black;
			}
		}

		&--dark {
			.ProductsItemClassic__name {
				color: white;
				font-family: 'Harrys-Regular', sans-serif;
			}

			.ProductsItemClassic__price {
				color: white;
				font-family: 'Harrys-Regular', sans-serif;
			}

			.ProductsItemClassic__action {
				background: transparent;
				color: white;
				border: 2px solid white;
				font-family: 'Harrys-Regular', sans-serif;
			}
		}
	}

	.item-details {
		&__list {
			padding-left: 28px;
			margin: 0;
			color: rgba(0, 0, 0, 0.6);
			font-size: 12px;
			line-height: 28px;
			white-space: pre-line;
			overflow-wrap: break-word;

			&--light {
				color: rgba(0, 0, 0, 0.6);
			}

			&--dark {
				color: rgba(255, 255, 255, 0.6);
				font-family: 'Futura-Book', sans-serif;
			}
		}
	}
</style>
